import { LOAD_WALLET, CREATE_WALLET } from 'config/Url';
import { getAuthOptions } from 'config/Headers';
import axios from 'interceptors/axiosInterceptor';
import { IGetQueryParams } from 'interfaces/Index';
import { SOMETHING_WENT_WRONG } from 'config/constants';
import { TOPUP_API_TYPE } from 'config/constants';

export const topupApiCall = (queryParam: IGetQueryParams, type: string) => {
  return new Promise<any>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    const errors = { errors: SOMETHING_WENT_WRONG };
    axios
      .post(
        type === TOPUP_API_TYPE.LOAD ? LOAD_WALLET : CREATE_WALLET,
        {},
        requestConfig
      )
      .then((response) => {
        if (response) {
          resolve(response.data);
        }
      })
      .catch((e) => {
        reject(errors);
      });
  });
};
